import axios from "axios";
import httpClient from "./httpClient";
import { PRICE_API } from "src/constants/misc";
interface HttpResponse {
  code: number;
  data: any;
}

export const getPrices = (): Promise<HttpResponse> => {
  return httpClient.get("/prices") as Promise<HttpResponse>;
};

export const getPrices_gns = (): Promise<HttpResponse> => {
  return httpClient.get("/gnsprices") as Promise<HttpResponse>;
};

export const getTokenPrice = (): Promise<HttpResponse> => {
  return httpClient.get(
    `https://api.dexscreener.com/latest/dex/pairs/zksync/0x85a60656b85ebbac1b7567476f2a6fa0f229e52e`
  ) as Promise<HttpResponse>;
};
export const getPythPrices = async (
  ids: string[],
  chainId: number
): Promise<any> => {
  // const chainIds = process.env.REACT_APP_NETWORKID as string;
  const baseUrl = PRICE_API[chainId];
  try {
    const data = await axios.get(baseUrl, {
      params: {
        ids: ids,
      },
    });
    const priceData = data.data.reduce((acc: any, id: any) => {
      const buffer = Buffer.from(id, "base64");
      const priceData = "0x" + buffer.toString("hex");
      acc.push(priceData);
      return acc;
    }, []);
    // const value = toWei(ids.length, 15).toNumber();
    const value = ids.length;
    return { priceData, value };
  } catch (error) {
    console.log("[error]:", error);
  }
  return false;
};
